import FinalizeClassAttendanceDataIcon from '@material-ui/icons/ViewList';

import FinalizeMealRegistrationList from './FinalizeMealRegistrationList';

export default {
    list: FinalizeMealRegistrationList,
    icon: FinalizeClassAttendanceDataIcon,
};
